import {
  SelectionProviderChildProps,
  VerticalFlexContainer
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { DatabaseQuery_databases } from '../../../gen-src/queries/DatabaseQuery';
import { PaneWithTitle } from '../placePage/PaneWithTitle';
import { TablesGridSortProvider } from '../sorting/sortProviders/TablesGridSortProvider';
import { DatabaseDetails } from './DatabaseDetails';
import { DatabaseTablesQueryGrid } from './DatabaseTablesQueryGrid';

export interface DatabaseTablesPaneProps extends SelectionProviderChildProps {
  readonly title: string;
  readonly database: DatabaseQuery_databases;
  readonly databaseId: string;
  readonly rowCount: number | null;
}

export function DatabaseTablesPane(props: DatabaseTablesPaneProps): JSX.Element {
  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <DatabaseDetails database={props.database} />
      <PaneWithTitle title={props.title}>
        <TablesGridSortProvider>
          {({ orderBy, updateSortOrder }) =>
            <DatabaseTablesQueryGrid
              databaseId={props.databaseId}
              selectedKeys={props.selectedKeys}
              updateSelectionForKey={props.updateSelectionForKey}
              rowCount={props.rowCount}
              orderBy={orderBy}
              updateSortOrder={updateSortOrder}
            />
          }
        </TablesGridSortProvider>
      </PaneWithTitle>
    </VerticalFlexContainer>
  );
}
